export default {
  menuActiveMap: {
    Dashboard: "Dashboard",
    Role: "Role",
    Resource: "Resource",
    ResourceTrabscoding: "Resource",
    VipChannel: "VipChannel",
    VipChannelCreate: "VipChannel",
    VipChannelUpdate: "VipChannel",
    Download: "Download",
    DownloadCreate: "Download",
    DownloadUpdate: "Download",
    Addrole: "Role",
    Editrole: "Role",
    Orderlist: "Orderlist",
    OrderDetail: "Orderlist",
    OrderRefund: "Orderlist",
    Promocode: "Promocode",
    Createcode: "Promocode",
    CreateMulticode: "Promocode",
    CodeImport: "Promocode",
    PromoCodeRule: "Promocode",
    PromoCodeRuleCreate: "Promocode",
    PromoCodeRuleUpdate: "Promocode",
    WithdrawOrders: "WithdrawOrders",
    SystemIndex: "SystemIndex",
    SystemConfig: "SystemIndex",
    SystemPlayerConfig: "SystemIndex",
    SystemMpwechatConfig: "SystemIndex",
    SystemLiveConfig: "SystemIndex",
    SystemMessageConfig: "SystemIndex",
    SystemCreditSignConfig: "SystemIndex",
    SystemSaveImagesConfig: "SystemIndex",
    SystemVideoHlsConfig: "SystemIndex",
    SystemTopicConfig: "SystemIndex",
    SystemBookConfig: "SystemIndex",
    SystemPaymentConfig: "SystemIndex",
    SystemVideoSaveConfig: "SystemIndex",
    LoadingScreen: "SystemIndex",
    Roles: "SystemIndex",
    Version: "SystemIndex",
    SystemAppHome: "SystemIndex",
    SingleBuy: "SystemIndex",
    Groupsettingio: "SystemIndex",
    SystemApplication: "SystemApplication",
    AdministratorChangePassword: "Dashboard",
    SystemAdministrator: "SystemAdministrator",
    AdministratorCreate: "SystemAdministrator",
    AdministratorUpdate: "SystemAdministrator",
    SystemAdminroles: "SystemAdministrator",
    AdminrolesCreate: "SystemAdministrator",
    AdminrolesUpdate: "SystemAdministrator",
    Vod: "Vod",
    VodUserImport: "Vod",
    VodImport: "Vod",
    VodCreate: "Vod",
    VodUpdate: "Vod",
    VodView: "Vod",
    CourseCategories: "Vod",
    CategoriesCreate: "Vod",
    CategoriesUpdate: "Vod",
    CourseChapters: "Vod",
    ChaptersCreate: "Vod",
    ChaptersUpdate: "Vod",
    CourseAttach: "Vod",
    AttachCreate: "Vod",
    CourseVideos: "Vod",
    VideosCreate: "Vod",
    VideosUpdate: "Vod",
    VideoSubscribe: "Vod",
    VideoWatchRecords: "Vod",
    VideoComments: "Vod",
    CourseComments: "Vod",
    SinglePage: "SinglePage",
    SinglePageCreate: "SinglePage",
    SinglePageUpdate: "SinglePage",
    Meedubook: "Meedubook",
    MeedubookCreate: "Meedubook",
    MeedubookUpdate: "Meedubook",
    MeedubookComment: "Meedubook",
    MeedubookUsers: "Meedubook",
    MeedubookCategory: "Meedubook",
    MeedubookCategoryCreate: "Meedubook",
    MeedubookCategoryUpdate: "Meedubook",
    MeedubookChapter: "Meedubook",
    MeedubookChapterCreate: "Meedubook",
    MeedubookChapterUpdate: "Meedubook",
    MeedubookArticle: "Meedubook",
    MeedubookArticleCreate: "Meedubook",
    MeedubookArticleUpdate: "Meedubook",
    MeedubookArticleComment: "Meedubook",
    MemberIndex: "MemberIndex",
    MemberCreate: "MemberIndex",
    MemberProfile: "MemberIndex",
    MemberImport: "MemberIndex",
    MemberDetail: "MemberIndex",
    MemberEdit: "MemberIndex",
    MemberTag: "MemberIndex",
    MemberRemark: "MemberIndex",
    MemberCredit1: "MemberIndex",
    MemberTagIndex: "MemberIndex",
    MemberTagCreate: "MemberIndex",
    MemberTagEdit: "MemberIndex",
    MessageReply: "MessageReply",
    MpWechatMenu: "MessageReply",
    ReplyCreate: "MessageReply",
    ReplyUpdate: "MessageReply",
    Question: "Question",
    QuestionAnswer: "Question",
    QuestionComment: "Question",
    QuestionCategory: "Question",
    QuestionCategoryCreate: "Question",
    QuestionCategoryUpdate: "Question",
    MiaoshaOrders: "MiaoshaGoods",
    MiaoshaGoods: "MiaoshaGoods",
    MiaoshaGoodsCreate: "MiaoshaGoods",
    MiaoshaGoodsUpdate: "MiaoshaGoods",
    TuangouGoods: "TuangouGoods",
    TuangouGoodsCreate: "TuangouGoods",
    TuangouGoodsUpdate: "TuangouGoods",
    TuangouGoodsDetail: "TuangouGoods",
    TuangouGoodsOrder: "TuangouGoods",
    TuangouGoodsRefund: "TuangouGoods",
    TuangouGoodsTuanorder: "TuangouGoods",
    LearningPath: "LearningPath",
    LearningPathCreate: "LearningPath",
    LearningPathUpdate: "LearningPath",
    LearningPathCategories: "LearningPath",
    LearningPathCategoriesCreate: "LearningPath",
    LearningPathCategoriesUpdate: "LearningPath",
    LearningStep: "LearningPath",
    LearningStepCreate: "LearningPath",
    LearningStepUpdate: "LearningPath",
    Steprelation: "LearningPath",
    SteprelationCreate: "LearningPath",
    SteprelationUpdate: "LearningPath",
    MultiPoster: "MultiPoster",
    MultiPosterCreate: "MultiPoster",
    MultiPosterUpdate: "MultiPoster",
    ShareGoods: "ShareGoods",
    ShareGoodsCreate: "ShareGoods",
    ShareGoodsUpdate: "ShareGoods",
    LiveCourse: "LiveCourse",
    LiveTeacher: "LiveCourse",
    LiveTeacherCreate: "LiveCourse",
    LiveTeacherUpdate: "LiveCourse",
    LiveCourseCreate: "LiveCourse",
    LiveCourseUpdate: "LiveCourse",
    LiveCourseComment: "LiveCourse",
    LiveCourseCategory: "LiveCourse",
    LiveCourseCategoryCreate: "LiveCourse",
    LiveCourseCategoryUpdate: "LiveCourse",
    LiveCourseChapter: "LiveCourse",
    LiveCourseChapterCreate: "LiveCourse",
    LiveCourseChapterUpdate: "LiveCourse",
    LiveCourseUsers: "LiveCourse",
    LiveCourseVideo: "LiveCourse",
    LiveCourseVideoCreate: "LiveCourse",
    LiveCourseVideoUpdate: "LiveCourse",
    LiveCourseVideoPlay: "LiveCourse",
    LiveCourseVideoWatchusers: "LiveCourse",
    LiveCourseVideoChat: "LiveCourse",
    CodeExchanger: "CodeExchanger",
    CodeExchangerCreate: "CodeExchanger",
    CodeExchangerUpdate: "CodeExchanger",
    CodeExchangerCodes: "CodeExchanger",
    CodeExchangerCategory: "CodeExchangerCategory",
    CodeExchangerCategoryCreate: "CodeExchangerCategory",
    CodeExchangerCategoryUpdate: "CodeExchangerCategory",
    CodeExchangerClassify: "CodeExchangerCategory",
    CodeExchangerClassifyCreate: "CodeExchangerCategory",
    CodeExchangerClassifyUpdate: "CodeExchangerCategory",
    Topic: "Topic",
    TopicCreate: "Topic",
    TopicUpdate: "Topic",
    TopicCategory: "Topic",
    TopicCategoryCreate: "Topic",
    TopicCategoryUpdate: "Topic",
    TopicComment: "Topic",
    TopicOrder: "Topic",
    ExamPaper: "ExamPaper",
    ExamPaperShow: "ExamPaper",
    ExamPaperCreate: "ExamPaper",
    ExamPaperUpdate: "ExamPaper",
    PaperCategories: "ExamPaper",
    PaperCategoriesCreate: "ExamPaper",
    PaperCategoriesUpdate: "ExamPaper",
    ExamPaperUserpaper: "ExamPaper",
    ExamPaperStat: "ExamPaper",
    PaperUser: "ExamPaper",
    ExamPaperQuestion: "ExamPaper",
    ExamPaperQuestionCreate: "ExamPaper",
    ExamPractice: "ExamPractice",
    ExamPracticeCreate: "ExamPractice",
    ExamPracticeUpdate: "ExamPractice",
    PracticeCategories: "ExamPractice",
    PracticeCategoriesCreate: "ExamPractice",
    PracticeCategoriesUpdate: "ExamPractice",
    PracticeChapter: "ExamPractice",
    PracticeChapterCreate: "ExamPractice",
    PracticeChapterUpdate: "ExamPractice",
    PracticeChapterQuestion: "ExamPractice",
    PracticeChapterQuestionCreate: "ExamPractice",
    PracticeUser: "ExamPractice",
    PracticeProgress: "ExamPractice",
    ExamMockpaper: "ExamMockpaper",
    ExamMockpaperShow: "ExamMockpaper",
    ExamMockpaperCreate: "ExamMockpaper",
    ExamMockpaperUpdate: "ExamMockpaper",
    MockpaperCategories: "ExamMockpaper",
    MockpaperCategoriesCreate: "ExamMockpaper",
    MockpaperCategoriesUpdate: "ExamMockpaper",
    MockpaperUser: "ExamMockpaper",
    ExamMockpaperStat: "ExamMockpaper",
    ExamMockpaperUserpaper: "ExamMockpaper",
    ExamQuestion: "ExamQuestion",
    ExamQuestionCreate: "ExamQuestion",
    ExamQuestionUpdate: "ExamQuestion",
    ExamQuestionImport: "ExamQuestion",
    SnapshotIndex: "SnapshotIndex",
    SnapshotImages: "SnapshotIndex",
    CourseVodVideoAliyunHls: "Vod",
    CourseVodVideoTencentHls: "Vod",
    K12Teacher: "K12Course",
    K12TeacherCreate: "K12Course",
    K12TeacherUpdate: "K12Course",
    K12Course: "K12Course",
    K12CourseCreate: "K12Course",
    K12CourseUpdate: "K12Course",
    K12Categories: "K12Course",
    K12CategoriesCreate: "K12Course",
    K12CategoriesUpdate: "K12Course",
    K12CourseOrder: "K12Course",
    K12CourseOrderTeacher: "K12Course",
    ExamQuestionCategories: "ExamQuestion",
    ExamQuestionCategoriesCreate: "ExamQuestion",
    ExamQuestionCategoriesUpdate: "ExamQuestion",
    CreditMall: "CreditMall",
    CreditMallCreate: "CreditMall",
    CreditMallUpdate: "CreditMall",
    CreditMallOrders: "CreditMall",
    CreditMallOrdersUpdate: "CreditMall",
    CreditMallOrdersSend: "CreditMall",
    CreditMallTask: "CreditMall",
    CreditMallTaskCreate: "CreditMall",
    CreditMallTaskUpdate: "CreditMall",
    ExtendQuDao:"ExtendQuDao",
    ExtendCreate:"ExtendQuDao",
    ExtendUpdate:"ExtendQuDao",
    TwinsVerse:"TwinsVerse",
    TwinsVerseCreate:"TwinsVerse",
    TwinsVerseUpdate:"TwinsVerse",
    HomeTask:"HomeTask",
    HomeTaskCreate:"HomeTask",
    HomeTaskUpdate:"HomeTask",
    Message:"Message",
    MessageCreate:"Message",
    MessageUpdate:"Message",
    BadgeModule:"BadgeModule",
    BadgeModuleCreate:"BadgeModule",
    BadgeModuleUpdate:"BadgeModule",
    Help:"Help",
    HelpCreate:"Help",
    HelpUpdate:"Help",
    HelpCategory:"Help",
    HelpCategoryCreate:"Help",
    HelpCategoryUpdate:"Help",
    HelpFeedback:"Help",
    VersionUpdating:"VersionUpdating",
    VersionUpdatingCreate:"VersionUpdating",
    VersionUpdatingUpdate:"VersionUpdating",
    VersionUpdatingCategory:"VersionUpdating",
    VersionUpdatingCategoryCreate:"VersionUpdating",
    VersionUpdatingCategoryUpdate:"VersionUpdating",
    ClassIndex:"ClassIndex",
    ClassCreate:"ClassIndex",
    ClassUpdate:"ClassIndex",
    ResourceImage:"ResourceImage",
    GoodsSetting:"GoodsSetting",
    GoodsSettingCreate:"GoodsSetting",
    GoodsSettingUpdate:"GoodsSetting",
    Distribute:"Distribute",
    DistributeCreate:"Distribute",
    DistributeUpdate:"Distribute",
  },
};
